<template>
  <header>
    <div class="container flex-center relative z-10">
      <h1 class="header-title">
        <span class="top-line"></span>
        <i :class="icon" class="ml-2 text-white text-opacity-80"></i>
        {{ title }}
        <span class="bottom-line"></span>
      </h1>
    </div>
  </header>
</template>

<script>
export default {
  props: ['title', 'icon'],
  mounted() {
    setTimeout(() => {
      if (this.$route.path !== '/') {
        const el = document.querySelector('.header-title');
        if (el) el.classList.add('active');
      }
    }, 300);
  },
};
</script>
